import React, { useContext, useState, useEffect } from 'react'
import { ModalContext } from 'providers/Modal'
import { getCookie } from 'utils/cookie'
import Sticky from 'components/Sticky'
import 'styles/getStarted.scss'
import { trackButtonClick } from 'tracking/homepage'

const renderContent = () => {
  const { setActive } = useContext(ModalContext)
  const handleClick = () => {
    setActive('register')
    trackButtonClick({
      fieldValue: `Get Started`,
    })
  }
  return (
    <div className="getStartedWrapper">
      <div className="container">
        <div className="row">
          <div className="col-sm-6 storyHeading">
            Your story is waiting to happen!
          </div>
          <div className="col-md-6 startedWraper">
            <a
              data-testid="get_started"
              href="javascript:void(0)"
              className="getStartedBtn"
              onClick={handleClick}
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

function GetStarted() {
  const [state, setState] = useState({
    revampViewBucket: '',
  })
  useEffect(() => {
    const revampViewBucket = getCookie('revampView')
    setState({ revampViewBucket })
  }, [])

  return ['A', 'B', 'D'].includes(state.revampViewBucket) ? (
    <Sticky className={'getStartedFixWrap'}>{renderContent()}</Sticky>
  ) : (
    renderContent()
  )
}

export default GetStarted
